import { Component, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HcmTileSplashComponent } from '../hcm-tile-splash/hcm-tile-splash.component';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [CommonModule, HcmTileSplashComponent],
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SplashScreenComponent implements OnInit {
  showSplash = signal<boolean>(true);
  fadeOut = signal<boolean>(false);

  constructor(private router: Router) {
    setTimeout(() => {
      this.fadeOut.set(true);
      setTimeout(() => {
        this.showSplash.set(false);
      }, 600);
    }, 5500);  }

  ngOnInit(): void {
    // También ocultar cuando la navegación esté completa
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Si aún está visible, ocultar después de un pequeño delay
        if (this.showSplash()) {
          setTimeout(() => {
            this.fadeOut.set(true);
            setTimeout(() => {
              this.showSplash.set(false);
            }, 600);
          }, 1000);
        }
      });
  }
}
